import { Controller } from "stimulus";

export default class extends Controller {
  updateContactList(event) {
    const addressId = +event.target.value;
    const party = event.target.getAttribute("data-party");
    const contactSelect = document.getElementById(`${party}_contact_id`);

    contactSelect.innerHTML = "";
    this.pasteOption(contactSelect, "", "");
    JSON.parse(document.getElementById("contacts_arr").value)
      .filter((c) => c.company_address_id === addressId)
      .forEach((x) => {
        this.pasteOption(contactSelect, x.id, x.name);
      });
  }

  pasteOption(selector, value, text) {
    let element = document.createElement("option");
    element.value = value;
    element.textContent = text;
    selector.appendChild(element);
  }
}
